<div class="response-container">
	<div class="titleContainer">
		<h2>Responses</h2>
	</div>
	<div class="infoContainer">
		<div class="analytic-card" fxLayout="row" fxLayout.lt-lg="column" fxLayout.lt-md="column" fxLayout.lt-sm="column" fxLayout.lt-xs="column" fxLayoutAlign="space-between center">
			<ng-container *ngIf="!['Mobile Justice'].includes(app)">
				<div class="summary-card" fxFlex>
					<portals-loading [showIf]="formLoading">
						<mat-card class="incidents">
							<mat-card-content fxLayout="row" fxLayoutAlign="space-between center" class="project">
								<img class="sub-detail-image" src="/assets/images/total-alt.png" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ allProjectCount | count }}
									</h2>
									<small>Responses</small>
								</div>
							</mat-card-content>
						</mat-card>
					</portals-loading>
				</div>
			</ng-container>

			<ng-container *ngIf="['Mobile Justice'].includes(app)">
				<div class="summary-card" fxFlex>
					<portals-loading [showIf]="formLoading">
						<mat-card class="incidents" fxLayout="row" fxLayoutAlign="center">
							<mat-card-content *ngIf="!admin" fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="project">
								<img class="sub-detail-image" src="/assets/images/total-alt.png" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ allProjectCount | count }}
									</h2>
									<small>Affiliate Incidents</small>
								</div>
							</mat-card-content>
							<mat-card-content fxFlex fxLayout="row" fxLayoutAlign="space-between center" [ngClass]="admin ? 'project' : 'national'">
								<img class="sub-detail-image" [src]="admin ? '/assets/images/total-alt.png' : '/assets/images/total.png'" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ allCount | count }}
									</h2>
									<small>National Incidents</small>
								</div>
							</mat-card-content>
						</mat-card>
					</portals-loading>
				</div>
			</ng-container>

			<ng-container *ngIf="!['Mobile Justice'].includes(app)">
				<div class="summary-card" fxFlex>
					<portals-loading [showIf]="formLoading">
						<mat-card class="videos">
							<mat-card-content fxLayout="row" fxLayoutAlign="space-between center" class="national">
								<img class="sub-detail-image" src="/assets/images/video-alt.png" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ projectVideoCount | count }}
									</h2>
									<small>Videos</small>
								</div>
							</mat-card-content>
						</mat-card>
					</portals-loading>
				</div>
			</ng-container>

			<ng-container *ngIf="['Mobile Justice'].includes(app)">
				<div class="summary-card" fxFlex>
					<portals-loading [showIf]="formLoading">
						<mat-card class="videos" fxLayout="row" fxLayoutAlign="center">
							<mat-card-content *ngIf="!admin" fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="project">
								<img class="sub-detail-image" src="/assets/images/video.png" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ projectVideoCount | count }}
									</h2>
									<small>Affiliate Videos</small>
								</div>
							</mat-card-content>
							<mat-card-content fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="national">
								<img class="sub-detail-image" src="/assets/images/video-alt.png" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ allVideoCount | count }}
									</h2>
									<small>National Videos</small>
								</div>
							</mat-card-content>
						</mat-card>
					</portals-loading>
				</div>
			</ng-container>

			<ng-container *ngIf="!['Mobile Justice'].includes(app)">
				<div class="summary-card" fxFlex>
					<portals-loading [showIf]="formLoading">
						<mat-card class="audio">
							<mat-card-content fxLayout="row" fxLayoutAlign="space-between center" class="national">
								<img class="sub-detail-image" src="/assets/images/audio-alt.png" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ projectAudioCount | count }}
									</h2>
									<small>Audios</small>
								</div>
							</mat-card-content>
						</mat-card>
					</portals-loading>
				</div>
			</ng-container>

			<ng-container *ngIf="!['Mobile Justice'].includes(app)">
				<div class="summary-card" fxFlex>
					<portals-loading [showIf]="formLoading">
						<mat-card class="text">
							<mat-card-content fxLayout="row" fxLayoutAlign="space-between center" class="national">
								<img class="sub-detail-image" src="/assets/images/report-alt.png" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ projectTextCount | count }}
									</h2>
									<small>Texts</small>
								</div>
							</mat-card-content>
						</mat-card>
					</portals-loading>
				</div>
			</ng-container>

			<ng-container *ngIf="['Mobile Justice'].includes(app)">
				<div class="summary-card" fxFlex>
					<portals-loading [showIf]="formLoading">
						<mat-card class="reports" fxLayout="row" fxLayoutAlign="center">
							<mat-card-content *ngIf="!admin" fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="project">
								<img class="sub-detail-image" src="/assets/images/report.png" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ projectReportCount | count }}
									</h2>
									<small>Affiliate Reports</small>
								</div>
							</mat-card-content>
							<mat-card-content fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="national">
								<img class="sub-detail-image" src="/assets/images/report-alt.png" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ allReportCount | count }}
									</h2>
									<small>National Reports</small>
								</div>
							</mat-card-content>
						</mat-card>
					</portals-loading>
				</div>
			</ng-container>

			<ng-container *ngIf="!['Jotto', 'Mobile Justice'].includes(app)">
				<div class="summary-card" fxFlex>
					<portals-loading [showIf]="formLoading">
						<mat-card class="police-reports">
							<mat-card-content fxLayout="row" fxLayoutAlign="space-between center" class="national">
								<img class="sub-detail-image" src="/assets/images/police-alt.png" />
								<div class="sub-detail" fxFlex>
									<h2>
										{{ projectPoliceReportCount | count }}
									</h2>
									<small>Police Reports</small>
								</div>
							</mat-card-content>
						</mat-card>
					</portals-loading>
				</div>
			</ng-container>
		</div>
		<div id="chart">
			<portals-loading [showIf]="formLoading">
				<portals-line [lineChartData]="lineChartData" [lineChartOptions]="lineChartOptions" [lineChartLegend]="lineChartLegend" [lineChartPlugins]="lineChartPlugins"></portals-line>
			</portals-loading>
			<div class="bottom-card" fxLayout="row" fxLayoutAlign="space-between center">
				<div fxLayout="row" fxLayoutAlign="space-between center">
					<span>Responses from</span>
                    <span>{{ currentFilters.startDate | date }} - {{ currentFilters.endDate | date }}</span>
                </div>
			</div>
		</div>
	</div>
</div>
